import { render, staticRenderFns } from "./ProfitableProducts.vue?vue&type=template&id=7523072a"
import script from "./ProfitableProducts.vue?vue&type=script&lang=js"
export * from "./ProfitableProducts.vue?vue&type=script&lang=js"
import style0 from "./ProfitableProducts.vue?vue&type=style&index=0&id=7523072a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports